import * as React from 'react';
import ReactTable from "react-table";
import 'react-table/react-table.css'
import { api } from '@src/services/api';
import { _ } from "@src/services/i18n";
import { classNames, css, mixin, vars, defaultProps, formatters } from '@src/services/theme';
import { Proto, Props, State } from '@src/components/Proto';
import { Box } from '@src/components';
import { DeviceMount } from '@src/components/Settings/Actions/DeviceMount';
import { isReadOnly } from 'services/user';

// typing
interface LocalProps extends Props {
    urlWorkflowBatteries: string;
    urlWorkflowMountBattery: string;
}
interface LocalState extends State {
    loading?: boolean;
    action: "MOUNT" | null;
    actioning?: any;
}

// style
const lvars = {
    counter: 60
}
const style = css`
    ${mixin.row2}

    > .table {
    }
    > .stats {
        > article {
            padding: 20px 0;
            text-align: center;
            .iconBadge {
                ${mixin.iconBadge}
            }
        }
    }
`;

// component
export class DevicesToSet extends Proto<LocalProps, LocalState> {

    MountBtn = () => {
        return row => {
            if (isReadOnly()) return null;
            const act = row.original.mounted ? 'unmount' : 'mount';
            return (
                <div onClick={(e) => e.stopPropagation()}>
                    <button
                        className="btn btn-success"
                        onClick={(e) => {
                            this.openAction(act, row.original);
                        } }
                    >
                        {_(`${act}_battery_btn`, 'Dash')}
                    </button>
                </div>
            );
        }
    }

    openAction = (action, row) => {
        const {  } = this.props;
        this.setState({
            action: action.toUpperCase(),
            actioning: row.devid
        });
    }

    reload = async () => {
        this.setState({loading: true});
        let { get } = this.props;
        const res = await api({
            url: get,
            method: 'get',
            memoization: false
        });
        this.setState({
            data: res.data,
            loading: false
        });
    }
    
	// render
	render() {
        const $loading = this.loading();
        if ($loading) return $loading;
        const { onBattery } = this.props;
        const { data, action, actioning, loading } = this.state;
        const columns = [
            { Header: _('devicestoset_col_device', 'Dash'), id: 'serialno', accessor: v => v.serialno || v.devid },
            { Header: _('devicestoset_col_description', 'Dash'), id: "description", accessor: v => v.description || "" },
            { Header: _('devicestoset_col_installed_at', 'Dash'), id: "installed_at", accessor: v => v.install_date ? formatters.date(v.install_date) : "" },
            { Header: _('devicestoset_col_technology', 'Dash'), id: "technology", accessor: v => v.technology ? v.technology : "" },
            { Header: _('devicestoset_col_voltage', 'Dash'), id: "voltage", accessor: v => v.voltage ? `${v.voltage} V` : "", className: "number" },
            { Header: _('devicestoset_col_capacity', 'Dash'), id: "capacity", accessor: v => v.capacity ? `${v.capacity} Ah` : "", className: "number" },
            {
                Header: '',
                accessor: 'mount',
                maxWidth: 100,
                Cell: this.MountBtn(),
                sortable: false,
            }
        ];
        
        const tableProps = {
            loading,
            ...defaultProps.table({
                showPagination: true,
                onClick: (item) => { if (onBattery) onBattery({id: item.battery.id}); }
            }),
        }
		return (
            <>
                {(action === "MOUNT") &&
                <DeviceMount
                    id={actioning}
                    get={this.props.urlWorkflowBatteries}
                    mount={this.props.urlWorkflowMountBattery}
                    action={action.toLowerCase()}
                    onSuccess={() => { this.setState({ action: null }); this.reload(); } }
                    onCancel={() => this.setState({ action: null })}
                />
                }
                <Box title={_('devicestoset_title', 'Dash')} collapsed={false}>
                    <div className={style}>
                        <section className="stats">
                            <article>
                                <span className="iconBadge">
                                    <i className="icon-bms" />
                                    <strong>{data.data.length}</strong>
                                </span>
                            </article>
                        </section>
                        <section className="table">
                            <ReactTable
                                {...tableProps}
                                data={data.data}
                                columns={columns}
                            />
                        </section>
                    </div>
                </Box>
            </>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Dash/DevicesToSet.tsx